export const defaultState = {
  fileError: false,
  file: null,
  loading: false,
  deleted: false,
  errors: null,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitDocuments/UploadDocument/defaultState.js